import { render, staticRenderFns } from "./team-page-list.vue?vue&type=template&id=5d7eb824&scoped=true&"
import script from "./team-page-list.vue?vue&type=script&lang=js&"
export * from "./team-page-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7eb824",
  null
  
)

export default component.exports